import { ProjectItemGroupType, ProjectItemType } from "../types";

export const isGroup = (
  item: ProjectItemType
): item is ProjectItemGroupType => {
  return item.content_model === "ProjectGroup";
};
